import React, { FC } from 'react';
import { Wrapper } from './ad.style';
import { AdProps,  AdSizesProps } from './ad.types';
import { withTheme } from 'styled-components';

const ensureString = (data: any) => {
  
  return (typeof data !== 'string') ? JSON.stringify(data) : data;

};

const getAdSlots = (adSizes:Array<AdSizesProps>, isOutOfPage: boolean) => {
  return adSizes && adSizes.map((ad:  AdSizesProps) => {
    const { containerId, contentId, breakpoints, sizes } = ad;  
    const containerIdClass = containerId || `ad-${contentId}`;
    const dataSizes: any = (!isOutOfPage) ? sizes : null;  
    const dataSizesString =  ensureString(dataSizes);
    const breakpointsString = ensureString(breakpoints);

    return (
        <Wrapper id={containerIdClass} key={containerIdClass} data-thresholds={breakpointsString} className={'ad-responsive-size'} data-sizes={dataSizesString} />
    );
  });
}

const Ad: FC<AdProps> = ({
  adSizes,
  className,
  isOutOfPage = false,
  adunit,
  targeting,
  pageTargeting, 
  dataAttr
}: AdProps) => {

  const wrapperClassName =  ['ad-responsive-slot', className].join(' '); 
  const adSlots = getAdSlots(adSizes, isOutOfPage);
  const targetingString = ensureString(targeting);
  const pageTargetingString = ensureString(pageTargeting);
  
  return (
    <Wrapper className={wrapperClassName} data-adunit={adunit} data-targeting={targetingString} data-page-targeting={pageTargetingString} {...dataAttr}>{adSlots}</Wrapper>
  );
};

export default withTheme(Ad);
